import type { FinanceDashboardCalculationState } from './types';

const FINANCE_DASHBOARD_READY_TTL_MS = 6 * 60 * 60 * 1000;

export const getFinanceDashboardExpiresAt = (
    state: FinanceDashboardCalculationState | undefined
) => {
    if (state?.status !== 'ready' || !state.calculatedAt) return null;

    const calculatedAt = Date.parse(state.calculatedAt);

    return Number.isNaN(calculatedAt) ? null : calculatedAt + FINANCE_DASHBOARD_READY_TTL_MS;
};

export const getFinanceDashboardRefetchInterval = (
    state: FinanceDashboardCalculationState | undefined,
    now = Date.now()
) => {
    if (state?.status === 'queued' || state?.status === 'processing') return 2000;

    if (state?.status !== 'ready') return false;
    if (state.result?.charts.grossProfitByPeriodStatus === 'pending') return 5000;

    const expiresAt = getFinanceDashboardExpiresAt(state);

    return expiresAt === null ? false : Math.max(1000, expiresAt - now + 1000);
};
